/** Offer-feature copy. No figures here: they render from data via `Num` / `Money` / `Percent`. */
export const OFFER_COPY = {
  claim: 'دریافت پیشنهاد',
  notNow: 'فعلاً نه',
  yours: 'پیشنهاد ویژهٔ شما',
  codeLink: 'کد تخفیف دارید؟',
  codeLabel: 'کد تخفیف',
  codeApply: 'اعمال کد',
  codeApplied: 'کد تخفیف اعمال شد.',
  renewsOnce: 'تمدید بعدی با قیمت کامل انجام می‌شه.',
  renewsForever: 'این تخفیف تا وقتی اشتراکتون بدون وقفه تمدید بشه باقی می‌مونه.',
  offerEnds:
    'تخفیف دوره‌ای اشتراک فعلی شامل این انتخاب نمی‌شه و با این تغییر تموم می‌شه؛ تمدیدهای بعدی با قیمت کامل حساب می‌شه.',
  extrasIntro: 'همراه این پرداخت',
  extraFreeMonths: 'اشتراک رایگان',
  extraTrialDays: 'دورهٔ آزمایشی بیشتر',
  extraSmsCredit: 'اعتبار پیامک',
  claimNowDone: 'پیشنهاد فعال شد.',
  timeLeft: 'مانده',
  until: 'تا',
} as const;
